// extracted by mini-css-extract-plugin
module.exports = {"div":"tooltip_div__2SKEF","button":"tooltip_button__3rBJ0","close":"tooltip_close__3D-5E","hide":"tooltip_hide__3Yrm5","show":"tooltip_show__3xvX1"};